import { UserData } from 'models/user';
import { Channel, StreamChat } from 'stream-chat';
import { CHAT_API_KEY } from 'util/constants';
import vehApi from 'util/veh-api';

const DEFAULT_REGION = 'na';
class LiveChatService {
  public chatClient: StreamChat;
  public chatChannel: Channel;
  public readonly chatChannelType = 'messaging';
  public readonly region = (window as any).REGION || DEFAULT_REGION;

  private chatApiKey = CHAT_API_KEY;

  public constructor(token: string = '') {
    this.chatClient = StreamChat.getInstance(this.chatApiKey);
    this.chatChannel = {} as Channel;
  }

  /**
   * get a list of vendor users provided the channel id
   * @param channelGroupId
   * @returns
   */
  public getVendorUserIds(channelGroupId: string): Promise<string[]> {
    return vehApi.getVendorUserIds(channelGroupId);
  }
  /**
   * creates a chat token for a specific user
   * @params userId - string
   */
  public createChatToken(userId: string): Promise<string> {
    return vehApi.createChatToken(userId);
  }

  /**
   * disconnect user completely
   */
  public async disconnect() {
    try {
      await this.chatClient.disconnectUser();
    } catch (e) {
      console.error('Error trying to disconnect user');
    }
  }

  public async connect(userData: UserData, channelGroupId: string, members: string[] = []): Promise<Channel> {
    if (!channelGroupId) {
      console.error('Chat Error: please provide a valid channel group id');
      return Promise.reject(null);
    }
    const token = await this.createChatToken(userData.code);
    const userName = `${userData.user_first_name.trim()} ${userData.user_last_name.trim().charAt(0)}`;
    const channelId = this.getChannelId(channelGroupId, userData.code);

    await this.chatClient.connectUser(
      {
        id: userData.code,
        name: userName,
      },
      token
    );

    this.chatChannel = this.chatClient.channel(this.chatChannelType, channelId, {
      name: userName,
      channel_group_id: channelGroupId,
    });
    // create and watch the channel
    await this.chatChannel.watch({ presence: true, watch: true });
    this.chatChannel.addMembers([`${userData.code}`, ...members]);

    return this.chatChannel;
  }

  private getChannelId(channelGroupId: string, userCode: string): string {
    return `${this.region}-${channelGroupId}-${userCode}`;
  }
}

export default new LiveChatService();
